module.exports = __webpack_public_path__ + "img/bank-logo-dark.582ce01f.png";